import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ProfileDownloads } from '@/features/profile-downloads'

const profileDownloadsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
  status: z.array(z.string()).optional(),
})

export type ProfileDownloadsSearchParams = z.infer<
  typeof profileDownloadsSearchSchema
>

export const Route = createFileRoute('/_authenticated/admin/profile-downloads')(
  {
    validateSearch: profileDownloadsSearchSchema,
    component: ProfileDownloads,
  }
)
